var map = {
	"./033-bm.webp": 1290,
	"./033-cn.webp": 1291,
	"./033.webp": 1292,
	"./13-bm.webp": 1293,
	"./13-cn.webp": 1294,
	"./13.webp": 1295,
	"./3-bm.webp": 1296,
	"./3-cn.webp": 1297,
	"./3.webp": 1298,
	"./angpao-bm.webp": 1299,
	"./angpao-cn.webp": 1300,
	"./angpao.webp": 1301
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1289;